const actions = [
  {
      title: 'Share your goal with others.',
      text: 'Share the goal you\'re looking to achieve with friends, family, or colleagues. Sharing your goal with others keeps you accountable, boosts motivation and makes it more likely that you\'ll succeed.',
  },
  {
      title: 'Talk about the support you need.',
      text: 'Friends and family can help you with your goal by providing motivation and encouragement. They can also support you when you might be struggling and help to get you back on track. Think about what help you might need and what you could ask others to support you with.',
  },
  {
      title: 'Ask for help.',
      text: 'Ask friends, relatives, or colleagues for support with your goal. For example, you could ask them to attend a group with you or help you to travel to an appointment, you could ask them to only buy you soft drinks or healthy snacks, or you could ask them if you can call them when you get the urge to smoke.',
  }
];

const tip = 'Share your goal and ask for practical help from family and friends. Getting support from others can boost your motivation and increase your chances of success!';

// eslint-disable-next-line import/no-anonymous-default-export
export default { actions, tip };
